





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Element as CanvasElement } from '@/store/types/element';
import PdfElement from './PdfElement.vue';
import OfficeToolbar from '../Toolbars/OfficeToolbar.vue';

@Component({
  components: {
    PdfElement,
    OfficeToolbar,
  },
})
export default class OfficeElement extends Vue {
  @Prop(String) filename!: string;
  @Prop(String) convertedRealname!: string;
  @Prop(Number) conversionStatus!: number;
  @Prop(Number) currentPage!: number;
  @Prop({ type: Object }) element!: CanvasElement;
  @Prop(Boolean) selected!: boolean;
  @Prop(Boolean) doubleSelected!: boolean;

  async mounted() {
    this.$parent.$parent.$emit('updateMoveableComponent', {
      keepRatio: true,
    });
  }
}
